import { Component, NgZone, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GoogleTagManagerService } from '../../../services/analytics/google-tag-manager.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-rts-welcome-overlay',
  templateUrl: './rts-welcome-overlay.component.html',
  styleUrls: ['./rts-welcome-overlay.component.scss'],
})
export class RtsWelcomeOverlayComponent {
  public active: string = '';
  public isMobile: boolean;
  private slideHeaders = {
    eligibleProcedures: 'rts_overlay_header_1',
    quickAccess: 'rts_overlay_header_2',
    ssFacilities: 'rts_overlay_header_3',
  };

  constructor(
    public dialogRef: MatDialogRef<RtsWelcomeOverlayComponent>,
    private ngZone: NgZone,
    private router: Router,
    private gtmService: GoogleTagManagerService,
    private translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.active = 'eligibleProcedures';
    this.isMobile = data.isMobile;
  }

  public nextSlide(gtmLabel?: string): void {
    this.pushToGtm(gtmLabel);
    if (!this.active) {
      this.active = 'eligibleProcedures';
    } else if (this.active === 'eligibleProcedures') {
      this.active = 'quickAccess';
    } else {
      this.active = 'ssFacilities';
    }
  }

  public updateActive(e): void {
    if (this.active !== e.target.getAttribute('data-name').toString()) {
      this.active = e.target.getAttribute('data-name').toString();
      this.pushToGtm('Click Navigation');
    }
  }

  public navigateToMarketing(gtmLabel?: string): void {
    this.router.navigate(['marketing/right-to-shop']);
    this.pushToGtm(gtmLabel);
    this.closeDialog();
  }

  public closeDialog(gtmLabel?: string): void {
    if (gtmLabel) {
      this.pushToGtm(gtmLabel);
    }
    this.ngZone.run(() => {
      this.dialogRef.close();
    });
  }

  private pushToGtm(gtmLabel: string): void {
    const slideTitle = this.translateService.instant(
      this.slideHeaders[this.active]
    );
    this.gtmService.pushToDataLayer({
      event: 'rts-welcome-overlay',
      rtsWelcomeOverlayAction: `RTS Welcome Page Pop-up ${slideTitle}`,
      rtsWelcomeOverlayLabel: gtmLabel,
    });
  }
}
